// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Button,

  Icon,
  Input,
  useDisclosure,
  Modal,
  ModalOverlay,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  FormHelperText,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import NiceButton from "components/NiceButton/NiceButton.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import MenuTable from "components/Tables/MenuTable";
import React, { useEffect, useState } from "react";
import allMenu from "api/menu/all-menu";
import createMenu from "api/menu/create-menu";
import { ToastContainer, toast } from 'react-toastify';
import IconBox from "components/Icons/IconBox";
import { RiPlantLine } from "react-icons/ri";
import { useParams } from "react-router-dom";

function Tables() {
  const { address, tourname } = useParams()
  const { colorMode } = useColorMode();
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [isLoading, setIsLoading] = useState(false);
  const [tablesTableData, setTablesTableData] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [reload, setReload] = useState(false);
  const [title, setTitle] = useState("");


  useEffect(() => {
    setIsLoading(true)
    allMenu(address).then((result) => {
      setTablesTableData(result.data)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsLoading(false)
    })
  }, [reload])
  function createMenuAction() {
    setIsCreateLoading(true)
    createMenu(address, title, "", "", 1).then((result) => {
      toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
      setTitle("")
      setReload(!reload);
      onClose()
    }).catch((err) => {
      console.error(err)
      if (err?.response?.status == 409)
        return toast.error("آدرس انتخابی تکراری است.", {
          position: "bottom-right"
        })
      else if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsCreateLoading(false)
    })
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader>
          <Flex justify='space-between' align='center' mb='1rem' w='100%'>
            <Text fontSize='md' color={textColor} fontWeight='bold'>
              منوهای نمایشگاه {tourname}
            </Text>
            <Button
              onClick={onOpen}
              variant='outlined'
              color={colorMode === "dark" && "white"}
              _hover={colorMode === "dark" && "none"}
              borderColor={colorMode === "dark" && "white"}
              minW='110px'
              maxH='35px'>
              ساخت منوی جدید
            </Button>
          </Flex>
        </CardHeader>
        <CardBody>

          <Table variant="simple" color={textColor}>
            <Thead>
              <Tr my=".8rem" pl="0px" color="gray.400" >
                <Th pl="0px" borderColor={borderColor} color="gray.400" >
                  عنوان
                </Th>
                <Th borderColor={borderColor} color="gray.400" >تاریخ ایجاد</Th>
                <Th borderColor={borderColor}></Th>
                <Th borderColor={borderColor}></Th>
              </Tr>
            </Thead>

            {
              (isLoading) ? (
                <tbody class='loading'>
                  <tr>
                    <td class="td-3"><span></span></td>
                    <td class="td-3"><span></span></td>
                    <td class="td-2"><span class='box'></span></td>
                    <td class="td-2"><span class='box'></span></td>
                  </tr>
                  <tr>
                  <td class="td-3"><span></span></td>
                    <td class="td-3"><span></span></td>
                    <td class="td-2"><span class='box'></span></td>
                    <td class="td-2"><span class='box'></span></td>
                  </tr>
                </tbody>
              ) :
                (
                  <Tbody>
                    {tablesTableData?.length > 0 ?
                      tablesTableData.map((row, index, arr) => {
                        return (
                          <MenuTable
                            isLast={index === arr.length - 1 ? true : false}
                            data={row}
                            key={index}
                            setReload={setReload}
                            reload={reload}
                          />
                        );
                      })
                      : <><tr><td colspan="6">
                        <Flex p="100px" align='center' w='100%'>
                          <IconBox as='box' w={"100%"} >
                            <Icon h={"150px"} w={"150px"} color={iconBlue} as={RiPlantLine} />
                          </IconBox>

                        </Flex>
                      </td></tr>
                      </>
                    }

                  </Tbody>
                )
            }

          </Table>
        </CardBody>
      </Card>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center" >ساخت منوی جدید</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mt={"20px"} id="title">
              <FormLabel  fontSize={"xs"}>عنوان (فارسی)</FormLabel>
              <Input fontSize={"xs"} value={title} onChange={e => setTitle(e.target.value)} type="text" />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isCreateLoading}
              onClick={createMenuAction}
              fontSize='xs'
              w="100px"
            >
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default Tables;
